/*
 *   File :  success-confirmation.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description :  Success confirmation order
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React, { useState, useEffect } from 'react';

/*import styles*/
import styles from '../../styles/components/fundClass.module.scss';
import { SecondaryBtn, PrimaryBtn } from '../cta';

import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import { Toast } from '../note';

/*import components*/

export default function PauseMessageModal(props) {

    const [toastMessage, setToastMessage] = useState(null);
    const [loader, setLoader] = useState(false);
    
    useEffect(() => {
        var my_modal = document.getElementById("pause-message-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleCloseModal();
        });
        //eslint-disable-next-line
    }, [props.handleCloseDateModal]);

    useEffect(() => {
        if (toastMessage !== null) {
            setTimeout(() => {
                setToastMessage(null);
            }, 4000);
        }
    }, [toastMessage])

    const _handleCloseModal = () => {
        document.getElementById("close-pscm").dispatchEvent(new Event("click"));
    };

    const _pauseSchedule = () => {
        setLoader(true);
        const url = devconfig.admin + "/notification/schedule-pause";
        let payload = JSON.stringify({
            schedule_id: props.id
        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setToastMessage({ type: 'success', message: 'Message has been paused' });
                setTimeout(() => {
                    _handleCloseModal();
                    props.success();
                }, 1000);
            } else {
                setToastMessage({ type: 'error', message: response.message });
            }
            setLoader(false);
        })
    }

    const _resumeSchedule = () => {
        setLoader(true);
        const url = devconfig.admin + "/notification/schedule-resume";
        let payload = JSON.stringify({
            schedule_id: props.id
        });
        APIPost(url, payload).then((response) => {
            if (response.status_code === 200) {
                setToastMessage({ type: 'success', message: 'Message has been resumed' });
                setTimeout(() => {
                    _handleCloseModal();
                    props.success();
                }, 1000);
            } else {
                setToastMessage({ type: 'error', message: response.message });
            }
            setLoader(false);
        })
    }


    return (
        <div className={`${styles.e_add_fund} modal fade`}
            id={"pause-message-modal"}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="pause-message-modal"
            aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className="modal-content">
                    <button id="close-pscm"
                        type="button"
                        className="btn-close d-none"
                        data-bs-dismiss="modal"
                        onClick={_handleCloseModal} >
                    </button>
                    <img src={props.resume ? require("../../assets/images/modal/resume.png").default : require("../../assets/images/modal/pause.png").default}
                        alt="success"
                        width={62}
                        height={62}
                        className='mx-auto mt-1' />
                    <h6 className='pt-4 mt-3 mb-4 pb-2 text-center'>{props.message}</h6>
                    <div className="row pb-1">
                        <div className="col-lg-12">
                            <div className="d-flex justify-content-center gap-3">
                                {
                                    // props.resume ?
                                    //     <PrimaryBtn
                                    //         name="Resume"
                                    //         handleClick={_cancelSchedule}
                                    //     />
                                    //     :
                                        <SecondaryBtn
                                            name={props.resume ? "Resume message" : "Pause message"}
                                            className={loader ? "e-btn-loader e-disabled e-modal-submit-blue" : 'e-modal-submit-blue'}
                                            handleClick={() => {props.resume ? _resumeSchedule() : _pauseSchedule()} }/>
                                }

                                <SecondaryBtn
                                    name="Cancel"
                                    className={`${styles.e_cancel} e-cancel`}
                                    cancel="modal" />
                            </div>

                        </div>
                    </div>
                </div>
            </div >
            {
                toastMessage !== null ?
                    <Toast data={toastMessage.message}
                        type={toastMessage.type}
                        id="2" />
                    :
                    null
            }
        </div>

    )
}
